import { FC } from 'react';
import { ResetButton } from '~/shared/components/Button/ResetButton';
import ChevronIcon from '~/icons/chevron.svg';
import { useFilterAttribute } from '../useFilterAttribute';
import styles from './FilterListRow.module.scss';

type FilterListRowProps = {
    attribute: string;
    onSelect: (attribute: string) => void;
};

export const FilterListRow: FC<FilterListRowProps> = ({ attribute, onSelect }) => {
    const { label, selectedLabel } = useFilterAttribute(attribute);

    return (
        <ResetButton className={styles.row} onClick={() => onSelect(attribute)}>
            {label}

            <span className={styles.facetContainer}>
                {selectedLabel && <span className={styles.countPill}>{selectedLabel}</span>}
                <ChevronIcon className={styles.chevron} />
            </span>
        </ResetButton>
    );
};
